import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { LabelStyled } from 'petco-ui/elements/form/label/Label.styled';

const modifiers = {
  default: () => ({
    styles: `
      font-size: 0.9375rem;
    `,
  }),
  inverted: ({ theme }) => ({
    styles: `
      color: ${theme.primary.contrastText};
    `,
  }),
  required: ({ theme }) => ({
    styles: `
      font-size: 0.9375rem;

      &::before {
        content: "";
      }

      &::after {
        content: "*";
        color: ${theme.status.danger};
      }
    `,
  }),
};

const Label = styled(LabelStyled)`
  ${applyStyleModifiers(modifiers)};
`;

export default Label;
